module.exports = {"610428001":"昭仁街道","610428101":"相公镇","610428102":"巨家镇","610428103":"丁家镇","610428104":"洪家镇","610428105":"亭口镇","610428106":"彭公镇","610428108":"枣园镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610428.json
// module id = 2952
// module chunks = 0